import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ReportsImportService {
  constructor( private readonly http  : HttpClient) { }
  baseURL = environment.baseAPIURL;

  private joinSelectedLabels(selectedItems: any[] = []): string {
    return (Array.isArray(selectedItems) ? selectedItems : [])
      .map((item) => (item?.label ?? '').toString().trim())
      .filter((label) => label.length > 0)
      .join(',');
  }

  getReportsImport(selectedImportPlant: any, selectedImportLP: any, selectedImportRoute: any, userContextPayload: any) {
    const payload = {
      event: {
        plantCode: this.joinSelectedLabels(selectedImportPlant),
        vendorId: this.joinSelectedLabels(selectedImportLP),
        routeType: this.joinSelectedLabels(selectedImportRoute)
      },
      userReqDto: userContextPayload?.userReqDto,
      isAdmin: !!userContextPayload?.isAdmin,
      userId: userContextPayload?.userId,
      userPrincipalName: userContextPayload?.userPrincipalName,
      firstName: userContextPayload?.firstName,
      lastName: userContextPayload?.lastName
    };

    const url: string = this.baseURL + '/aetReports/getAetImportTemplate';
    return this.http
      .post(
        url,
        payload,
        {observe: 'response', responseType: 'blob'}
      )
      .pipe(catchError(this.handleError));
  }
  private handleError(error: HttpErrorResponse) {
    return throwError(error.message || "Server Error");
  }
}
